import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { TouchableWithoutFeedback, View, ScrollView, Dimensions } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Modal } from '@/src/elements/modal/Modal'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'

import { DonationProgress } from '../DonationProgress'
import { MobileMessage } from '../MobileMessage'
import type { TDonationBannerBaseProps } from './DonationBanner.types'

export const MobileDonationBanner = ({
  donationData,
  messages,
  notes,
  signature,
  onClose,
  onDonate,
  onDonateLater,
  showDonationBanner,
}: TDonationBannerBaseProps & { showDonationBanner: boolean }): ReactNode => {
  return (
    <Modal
      showHandle={false}
      showModal={showDonationBanner}
      classNames={{ base: 'm-0 p-0 max-w-full' }}
      onCancel={onClose}
      testID={TEST_ID.DONATION.BANNER}
      maxDynamicContentSize={Dimensions.get('window').height}
    >
      <ScrollView
        className="flex-1 -mx-1 pb-4"
        showsVerticalScrollIndicator={false}
        style={{ paddingTop: 0, maxHeight: Dimensions.get('window').height * 0.91 }}
      >
        <TouchableWithoutFeedback>
          <View className="flex-column flex-1 max-w-full justify-between relative">
            <DonationProgress className="mb-4" donationData={donationData} />
            <View className="flex-column flex gap-3">
              {messages.map((message, index) => {
                const messageKey = `mobile-message-${index}`
                return <MobileMessage key={messageKey}>{message}</MobileMessage>
              })}
              <MobileMessage>{notes}</MobileMessage>
              <MobileMessage>{signature}</MobileMessage>
            </View>
            <Button
              startIcon={ICON.HEART}
              testID={TEST_ID.DONATION.DONATE_BUTTON}
              id={TEST_ID.DONATION.DONATE_BUTTON}
              colors="danger"
              size="md"
              className="my-8 w-full sticky bottom-0"
              onPress={onDonate}
            >
              <FormattedMessage id="app.i-donate" />
            </Button>
            <Button
              startIcon={ICON.BELL}
              colors="danger"
              size="sm"
              variant="light"
              className="w-full"
              onPress={onDonateLater}
            >
              <FormattedMessage id="app.donation.later.i-want" />
            </Button>
          </View>
        </TouchableWithoutFeedback>
      </ScrollView>
    </Modal>
  )
}
